export default function Devgrid (selector = '.devgrid') {
    let els = null
    let fn = null
    let handlers = null

    els = {
        grid: document.querySelector(selector)
    }

    fn = {
        init () {
            document.addEventListener('keyup', handlers.onKeyup)
        }
    }

    handlers = {
        onKeyup (e) {
            if (e.key === 'g' && e.ctrlKey || e.code === 'Backquote' && e.shiftKey) {
                els.grid.classList.toggle('state-hidden')
            }
        }
    }

    if (els.grid) {
        fn.init()
    }

    fn.init();
}
